export default "__VITE_PUBLIC_ASSET__b7136406__"